export default function INTP(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “منطق&zwnj;دان”</h1>{" "}
          <blockquote>
            <p>
              از دیروز بیاموز، برای امروز زندگی کن، به فردا امیدوار باش. مسئله
              مهم این است که دست از سؤال پرسیدن بر ندارید.
            </p>{" "}
            <footer>Albert Einstein</footer>
          </blockquote>{" "}
          <p>
            گونه شخصیتی منطق&zwnj;دان نسبتاً نادر است و تنها سه درصد از جمعیت را
            شامل می&zwnj;شود که قطعاً خبر خوبی برای آنها است چرا که هیچ چیزی به
            اندازه "رایج بودن" باعث نارضایتی آنها نمی&zwnj;شود. منطق&zwnj;دانان
            به نوآوری و خلاقیت، دیدگاه منحصر به فرد و عقل نیرومند خود مباهات
            می&zwnj;کنند. منطق&zwnj;دانان که معمولاً به&zwnj;عنوان فیلسوف،
            متفکر، یا استاد رؤیاپرداز شناخته می&zwnj;شوند، مسئول بسیاری از
            اکتشافات علمی در طول تاریخ بوده&zwnj;اند
          </p>{" "}
          <h2>زندگی آزموده نشده ارزش زیستن ندارد</h2>{" "}
          <blockquote className="no-footer">
            <p>
              منطق&zwnj;دانان به&zwnj;خاطر نظریه&zwnj;های درخشان و منطق نیرومند
              خود شناخته می&zwnj;شوند - در حقیقت، آن&zwnj;ها منطقی&zwnj;ترین
              گونه بین تمام گونه&zwnj;های شخصیتی در نظر گرفته می&zwnj;شوند.
            </p>
          </blockquote>{" "}
          <p>
            افراد دارای گونه شخصیتی منطق&zwnj;دان عاشق الگوها هستند و تعیین
            اختلافات بین عبارات تقریباً نوعی سرگرمی برایشان به حساب می&zwnj;آید
            که باعث می&zwnj;شود دروغ گفتن به منطق&zwnj;دانها فکر خوبی نباشد. این
            مسئله باعث می&zwnj;شود دیگران نتوانند عبارت&zwnj;های منطق&zwnj;دانان
            را به&zwnj;راحتی هضم کنند - مسئله این نیست که منطق&zwnj;دانان صادق
            نیستند، بلکه شخصیت آنها به&zwnj;گونه&zwnj;ای است که افکار کاملاً شکل
            نگرفته را در میان می&zwnj;گذارند و از دیگران به عنوان یک جایگاهی
            برای طرح ایده&zwnj;ها و نظریه&zwnj;ها در بحث علیه خودشان استفاده
            کنند، و نه به&zwnj;عنوان طرفهای مکالمه واقعی.
          </p>{" "}
          <p>
            ممکن است این مسئله باعث شود این گونه شخصیتی غیرقابل اعتماد به نظر
            برسد، اما در واقع هیچ کس به اندازه منطق&zwnj;دانان مشتاق و قادر به
            تشخیص مشکل، بررسی عوامل و جزئیات بی&zwnj;پایانی که موضوع آنها را
            شامل می&zwnj;شود و تدوین راه حلی منحصر به فرد و ماندگار نیست - فقط
            نباید انتظار داشت که گزارش&zwnj;های پیشرفت را به موقع تحویل بدهند!
            افرادی که دارای گونه شخصیتی منطق&zwnj;دان هستند به فعالیت&zwnj;ها و
            نگهداری&zwnj;های عملی و روزمره علاقه&zwnj;ای ندارند، اما وقتی
            منطق&zwnj;دانان محیطی را پیدا می&zwnj;کنند که نبوغ خلاق و
            توانایی&zwnj;های بالقوه&zwnj;شان می&zwnj;تواند در آنجا ابراز شود،
            هیچ محدودیتی از نظر صرف زمان و انرژی برای تدوین راه&zwnj;حل
            نکته&zwnj;سنجانه و بی&zwnj;طرفانه خود ندارد.
          </p>{" "}
          <div className="scene"></div> <h2>خرد با حیرت آغاز می&zwnj;شود</h2>{" "}
          <p>
            ممکن است به نظر برسد که منطق&zwnj;دانان در افکاری پوچ و
            بی&zwnj;پایان سرگردان هستند، اما روند تفکر آنها بدون وقفه است و
            ذهنشان از لحظه&zwnj;ای که از خواب بیدار می&zwnj;شوند کارش را با طرح
            ایده&zwnj;ها شروع می&zwnj;کند. ممکن است این تفکر مداوم باعث شود
            منطق&zwnj;دانان به ظاهر افسرده و منزوی به نظر برسند، چرا که دائم در
            حال انجام بحثهایی تمام عیار در سر خود هستند، اما در واقع کاملاً آرام
            هستند و وقتی در کنار افرادی باشند که آنها را می&zwnj;شناسند یا
            علاقه&zwnj;های مشابهی با آنها دارند رفتاری دوستانه دارند. با این
            حال، زمانی که شخصیت&zwnj;های منطق&zwnj;دان در در میان چهره&zwnj;های
            ناآشنا باشند، این حالت جای خود را به خجالت&zwnj;زدگی می&zwnj;دهد و
            اگر باور داشته باشند که نتیجه گیری یا نظریه منطقی آنها مورد انتقاد
            قرار گرفته به سرعت حالت تهاجمی به خود بگیرند.
          </p>{" "}
          <p>
            هنگامی که منطق&zwnj;دانان هیجان&zwnj;زده هستند، ممکن است گفتگوی آنها
            با عدم انسجام همراه باشد زیرا سعی دارند زنجیره&zwnj;ای پیچیده از
            نتیجه&zwnj;گیری&zwnj;های منطقی را توضیح دهند که به شکل&zwnj;گیری شدن
            ایده آنها منجر شده است. اغلب اوقات، منطق&zwnj;دانان صرفاً ترجیح
            می&zwnj;دهند موضوع را به سرعت طرح کنند پیش از آنکه بتوان فهمید سعی
            دارند چه چیزی بگویند بجای اینکه تلاش کنند همه چیز را به زبان ساده
            مطرح کنند.
          </p>{" "}
          <p>
            عکس این مطلب نیز می&zwnj;تواند زمانی صادق باشد که مردم فرایندهای
            فکری خود را با اصطلاحات ذهنی و عواطف به شخصیت&zwnj;های منطق&zwnj;دان
            توضیح بدهند. تصور کنید که یک ساعت فوق&zwnj;العاده پیچیده، همه
            واقعیت&zwnj;ها و ایده&zwnj;های ممکن را در خود جذب کند، آنها را با
            حجم سنگینی از استدلال خلاق پردازش کند و منطقی&zwnj;ترین نتایج در
            دسترس را برگرداند- ذهن منطق&zwnj;دانان این&zwnj;گونه کار
            می&zwnj;کند، و این گونه تحمل کمی در برابر آچاری عاطفی دارند که
            می&zwnj;خواهد با ماشین&zwnj;های آنها سر و کله بزند.
          </p>{" "}
          <h2>
            بگذارید کسانی که می&zwnj;خواهند جهان را حرکت بدهند نخست خودشان را
            حرکت بدهند
          </h2>{" "}
          <p>
            علاوه بر این، بعید است منطق&zwnj;دانان اساساً شکایت&zwnj;های عاطفی
            را درک کنند، و دوستانشان حمایت عاطفی چندانی از آنها دریافت
            نمی&zwnj;کنند. افراد دارای گونه شخصیتی منطق&zwnj;دان ترجیح
            می&zwnj;دهند در عوض یک مجموعه پیشنهادهای منطقی را برای چگونگی حل و
            فصل موضوع&zwnj;های زیربنایی ارائه دهند، دیدگاهی که همنشینان
            حساس&zwnj;تر همیشه از آنها استقبال نمی&zwnj;کنند. این مسئله به
            احتمال زیاد در مورد بیشتر قراردادها و اهداف اجتماعی، مانند
            برنامه&zwnj;ریزی شام و ازدواج نیز تعمیم خواهد یافت زیرا
            منطق&zwnj;دانان به مراتب بیشتر نگران اصیل بودن و کارآمد بودن نتایج
            هستند.
          </p>{" "}
          <p>
            یکی از چیزهایی که واقعاً باعث می&zwnj;شود منطق&zwnj;دانان عقب بکشند
            ترس دائمی و فراگیر آنها از شکست است. شخصیت منطق&zwnj;دان آنقدر در پی
            ارزیابی مجدد افکار و نظریه&zwnj;های خود بوده و نگران است که مبادا
            قطعه مهمی از پازل را از قلم انداخته باشد، که ممکن است دچار خمودگی
            شود و در جهان نامشهودی که افکارش در آن هرگز واقعاً به&zwnj;کار بسته
            نمی&zwnj;شود از دست برود. غلبه بر این شک به خود بزرگترین چالشی است
            که منطق&zwnj;دانان به احتمال زیاد با آن مواجه هستند، اما هدیه معنوی
            - اعم از بزرگ و کوچک - که پس از اتمام کار به جهان ارزانی
            می&zwnj;دارند ارزش این مبارزه را دارد.
          </p>
        </article>
      </div>
    </div>
  );
}
